(function () {
    'use strict';

    angular.module("imApp").factory("prePickCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1052,
                    parameters: parms || {}
                });
            },
            listPrePick: function (parms) {
                return $ihttp.post({
                    method: 1053,
                    parameters: parms || {}
                });
            },
            saveToPrevious: function (setting) {
                return $ihttp.post({
                    method: 1054,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
